import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MainHeader, MainMenu } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import {
  CSPMenuStructure,
  CSPUserMenuStructure,
  CSPLiteModeMenuStructure,
  CSPLiteModeMUserMenuStructure
} from '../../../routes/CSPMenuStructure';
import { BrandContext } from '../../../contextProviders/brandContext';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';
import { AUTHENTICATION_TYPES } from '../../../constants/constants';

export const HorizontalMenu = ({ cspHeaderLogo }) => {
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isLiteModeEnabled = cspConfiguration?.IsLiteModeEnabled || false;
  const isLiveVetEnabled = cspConfiguration?.IsLiveVetEnabled || false;
  const isPayNowEnabled = cspConfiguration?.IsPayNowEnabled ?? true;
  const isNotificationPreferencesEnabled = cspConfiguration?.IsNotificationPreferencesEnabled ?? true;

  const { authenticationType } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];
  const isSsoAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;

  const {
    activeBrandContext: {
      brand,
      layout: { header }
    }
  } = useContext(BrandContext);

  // Remove contact details from the header configuration
  const customCspHeaderConfig = { ...header, contactDetails: null };
  return (
    <MainHeader
      {...{
        ...brand,
        logos: cspHeaderLogo,
        ...customCspHeaderConfig,
        headerNav: (
          <MainMenu
            key={`${isLiveVetEnabled}-${isLiteModeEnabled}-${isPayNowEnabled}`} // force remount when isLiteModeEnabled & isLiveVetEnabled value is changed
            {...{
              wrapper: {
                id: 'horizontal'
              },
              menuId: 'cspMainMenu',
              layout: 'horizontal',
              isHoverTrigger: true,
              menuItems: isLiteModeEnabled
                ? CSPLiteModeMenuStructure(isLiveVetEnabled)
                : CSPMenuStructure(isLiveVetEnabled, isPayNowEnabled)
            }}
            ariaLabel="Main navigation menu"
          />
        ),
        customUserNav: (
          <MainMenu
            key={`${isLiteModeEnabled}`} // force remount when isLiteModeEnabled value is changed
            {...{
              wrapper: {
                id: 'horizontal',
                customCssClass: 'userNavigation'
              },
              layout: 'horizontal',
              isHoverTrigger: true,
              menuId: 'cspMainMenu',
              menuItems: isLiteModeEnabled
                ? CSPLiteModeMUserMenuStructure(isSsoAuthentication)
                : CSPUserMenuStructure(isSsoAuthentication, isNotificationPreferencesEnabled)
            }}
            ariaLabel="Profile navigation menu"
          />
        )
      }}
    />
  );
};

HorizontalMenu.propTypes = {
  cspHeaderLogo: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      imageTitle: PropTypes.string,
      imageTitleDescription: PropTypes.string,
      redirectUrl: PropTypes.string
    })
  )
};
